export const notificationLinkClassName = `
    bg-gray-97 font-main
    flex items-start
    min-h-[94px] p-sm w-full
    cursor-pointer
    hover:bg-primaryblue-95
    active:bg-secondary
  `;
